(function () {
  'use strict';

  var money = function (cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- Filter chips ---------- */
  var chips = document.querySelectorAll('[data-fx-filter]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var f = chip.getAttribute('data-fx-filter');
      chips.forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('.fx-shop .fx-card').forEach(function (card) {
        card.hidden = !(f === 'all' || card.getAttribute('data-fx-cat') === f);
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-fx-drawer]');
  var itemsEl = document.querySelector('[data-fx-cart-items]');
  var totalEl = document.querySelector('[data-fx-cart-total]');
  var lastFocus = null;

  function setCount(n) {
    document.querySelectorAll('[data-fx-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function render(cart) {
    setCount(cart.item_count);
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="fx-drawer__empty">Dein Warenkorb ist leer.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (it, i) {
        var parts = it.product_title.split(' | ');
        var motif = parts.length > 1 ? parts[parts.length - 1] : it.product_title;
        var garment = parts.length > 1 ? parts[parts.length - 2] : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var img = it.image || '';
        return '<div class="fx-line">' +
          (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '<span></span>') +
          '<div><p class="fx-line__title">' + esc(motif) + '</p>' +
          '<p class="fx-line__variant">' + esc([garment, variant].filter(Boolean).join(' · ')) + '</p>' +
          '<div class="fx-line__row"><div class="fx-qty">' +
          '<button type="button" data-fx-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Menge verringern">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-fx-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Menge erhöhen">+</button>' +
          '</div><strong>' + money(it.final_line_price) + '</strong></div></div></div>';
      }).join('');
    }
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }

  function openDrawer() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fx-locked');
    var closeBtn = drawer.querySelector('.fx-icon-btn');
    if (closeBtn) closeBtn.focus();
    fetchCart();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fx-locked');
    if (lastFocus) lastFocus.focus();
  }

  document.querySelectorAll('[data-fx-cart-open]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  document.querySelectorAll('[data-fx-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  if (drawer) {
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fx-qty]');
      if (!b) return;
      b.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.getAttribute('data-fx-qty')), quantity: Math.max(0, Number(b.getAttribute('data-q'))) })
      }).then(function (r) { return r.json(); }).then(render).catch(fetchCart);
    });
  }

  /* ---------- Product page ---------- */
  var pdp = document.querySelector('[data-fx-product]');
  var jsonEl = document.querySelector('[data-fx-product-json]');
  if (pdp && jsonEl) {
    var product = JSON.parse(jsonEl.textContent);
    var form = pdp.querySelector('[data-fx-form]');
    var idInput = pdp.querySelector('[data-fx-variant-id]');
    var priceEl = pdp.querySelector('[data-fx-price]');
    var addBtn = pdp.querySelector('[data-fx-add]');
    var msg = pdp.querySelector('[data-fx-msg]');
    var fieldsets = pdp.querySelectorAll('[data-fx-option]');

    var selected = function () {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    };
    var findVariant = function (opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === o; });
      });
    };
    var markAvailability = function (opts) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('.fx-pill').forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[idx] = val;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    var update = function () {
      var opts = selected();
      fieldsets.forEach(function (fs, i) {
        var l = fs.querySelector('[data-fx-option-label]');
        if (l) l.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Nicht verfügbar'; return;
      }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability(selected());

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      var label = addBtn.textContent;
      addBtn.textContent = 'Wird hinzugefügt …';
      msg.textContent = '';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      }).then(function (r) {
        return r.json().then(function (d) { if (!r.ok) throw d; return d; });
      }).then(function () {
        addBtn.textContent = label; addBtn.disabled = false;
        openDrawer();
      }).catch(function (err) {
        addBtn.textContent = label; addBtn.disabled = false;
        msg.textContent = (err && err.description) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      });
    });
  }
})();
